<template>
	<div class="clothes" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="潮流服饰" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
		<van-row>
			<van-col span="24" class="content" :style="paddT">
         		<img src="../../assets/advDetail/fushi/clothes_1.jpg" />
				<img src="../../assets/advDetail/fushi/clothes_2.jpg" />
				<img src="../../assets/advDetail/fushi/clothes_3.jpg" />
			</van-col>
		</van-row>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
    	tel: '',
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	}
  },
  mounted() {
	
  }
};
</script>

<style lang="less">
.clothes {
	background: #ffd0e0;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.content{
		background: #ffd0e0;
		img{
			width: 100%;
			display: block;
		}
		p{
			padding: 0 16px 0 13px;
			.btn {
				width: 100%;
				height: 45px;
				line-height: 45px;
				display: block;
				text-align: center;
				font-size: 18px;
				border-radius: 22.5px;
				font-weight: bold;
				color: #fff;
				background: #F13264;
				margin-top: 23px;
				margin-bottom: 10px;
			}
			.phone{
				color: #fff;
				border: solid 1px #F13264;
			}
		}
		p:last-child{
			padding-bottom: 22px;
		}
	}
}

.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
